module.exports = __webpack_public_path__ + "img/button_start.37060079.svg";